import type { LegalCasesData, LegalCasesSummary } from './legalCasesType';

/**
 * Typed accessor for the backend's `legalCasesCountSummary` block. Returns null when the key is
 * ABSENT — never defaults a figure to 0 — because absent means "old polus / not ready" (no
 * boxes at all), while a real 0 means "0 Cases / No Open" in green. No arithmetic here.
 */
export function readLegalCasesSummary(legalCasesData?: LegalCasesData | null): LegalCasesSummary | null {
    return legalCasesData?.legalCasesCountSummary ?? null;
}
